import React from "react";
import { Route } from "react-router";
import ServiceUnavailablePage from "pages/ServiceUnavailable/ServiceUnavailablePage";
import Unauthorized from "pages/Unauthorized/Unauthorized";
import StatusUnapproved from "pages/Errors/StatusUnapproved";
import StatusUnapprovedAccount from "pages/Errors/StatusUnapprovedAccount";
import OrderNotFound from "pages/Errors/OrderNotFound";
import NotFoundPage from "pages/NotFound/NotFoundPage";

export const ErrorRoutes = (
	<>
		<Route
			path="/unavailable"
			element={<ServiceUnavailablePage />}
		/>
		<Route
			path="/unauthorized"
			element={<Unauthorized />}
		/>
		<Route
			path="/unapproved/:status"
			element={<StatusUnapproved />}
		/>
		<Route
			path="/unapproved/account"
			element={<StatusUnapprovedAccount />}
		/>
		<Route
			path="/ordernotfound"
			element={<OrderNotFound />}
		/>
		<Route
			path="/draftordernotfound"
			element={<OrderNotFound orderType="Draft" />}
		/>
		<Route
			path="*"
			element={<NotFoundPage />}
		/>
	</>
);
